import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UpdateUserFlowPage } from './update-user-flow.page';

const routes: Routes = [
  {
    path: '',
    component: UpdateUserFlowPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpdateUserFlowPageRoutingModule {}
